import React from "react";
import {
  Box,
  Paper,
  IconButton,
  Divider,
  useMediaQuery,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { AiFillHome, AiFillCaretRight } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Card from "@mui/material/Card";
import { ChevronRight } from "@mui/icons-material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { useDispatch, useSelector } from "react-redux";
import { SET_MENU } from "../../store/actions";
import Cookies from "js-cookie";
import NeedHelpButton from "ui-components/NeedHelpButton";
// import ProgressBar from './ProgressBar';

const BreadcrumbHeader = ({
  title,
  titleStyle = {},
  shouldGoBack = false,
  breadcrumbTitle = "",
  Actions = () => <NeedHelpButton />,
  customBackgroundColor,
  sx = {},
}) => {
  const location = useLocation().pathname;
  const routes = [
    { path: "/", breadcrumb: "Dashboard" },
    {
      path: "backrr_startups",
      breadcrumb: "Startups",
      children: [{ path: "*", breadcrumb: title }],
    },
    {
      path: "backrr_investors",
      breadcrumb: "Investors",
      children: [{ path: "*", breadcrumb: title }],
    },
    {
      path: "startup_purchases",
      breadcrumb: "Startup Purchases",
      children: [
        { path: "*", breadcrumb: title },
        { path: "subscriptions", breadcrumb: "Subscriptions" },
        { path: "one_time", breadcrumb: "One-Time Purchases" },
      ],
    },
    {
      path: "admin_settings",
      children: [
        { path: "", breadcrumb: "Admin Settings" },
        {
          path: "release_notes",
          children: [
            {
              path: "",
              breadcrumb: "Release Notes",
            },
            { path: "view_version", breadcrumb: "View" },
            { path: "add_version", breadcrumb: "Add" },
          ],
        },
        {
          path: "admin_users",
          children: [
            {
              path: "",
              breadcrumb: "Admin Users",
            },
            { path: "add_user", breadcrumb: "Add" },
            { path: "edit_user", breadcrumb: "Edit" },
          ],
        },
        {
          path: "offer_codes",
          children: [
            {
              path: "",
              breadcrumb: "Offer Codes",
            },
          ],
        },
        {
          path: "plans_pricing",
          children: [
            {
              path: "",
              breadcrumb: "Startup Pricing Page",
            },
          ],
        },
      ],
    },
    {
      path: "*",
      breadcrumb: "Backrr Startups",
    },
  ];

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isNotLargeScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const navigate = useNavigate();
  const open = useSelector((state) => state.customization.opened);
  const dispatch = useDispatch();
  const drawerToggle = () => {
    dispatch({ type: SET_MENU, opened: !open });
  };

  const breadcrumbs = useBreadcrumbs(routes);
  // Phones only have room for the page's own heading, so the parent trail is
  // dropped there and just the last crumb is rendered.
  const renderedCrumbs = React.useMemo(() => {
    const named =
      breadcrumbs?.filter(({ breadcrumb }) => Boolean(breadcrumb)) ?? [];
    return isSmallScreen ? named.slice(-1) : named;
  }, [breadcrumbs, isSmallScreen]);

  return (
    <>
      <Card
        sx={{
          padding: { xs: "1rem 1rem 0.5rem 1rem", sm: "1rem 2rem 0.5rem 2rem" },
          boxShadow: "none",
          borderRadius: { xs: 0, sm: "24px 0 0 0" },
          background: customBackgroundColor ? customBackgroundColor : "#fffdfa",
          ...sx,
        }}
      >
        <Box
          sx={{
            backgroundColor: customBackgroundColor
              ? customBackgroundColor
              : "#fffdfa",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flex: 1,
            maxHeight: 30,
          }}
          className="breadcrumb-flex-wrap"
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: { xs: 0, sm: 1 },
            }}
            className="breadcrumb-box"
          >
            {isNotLargeScreen && (
              <IconButton
                sx={{
                //   padding: 0,
                  display: "grid",
                  placeItems: "center",
                  marginRight: 1,
                }}
                size="small"
                onClick={drawerToggle}
              >
                {" "}
                <MenuRoundedIcon sx={{ fontSize: "1.8rem" }} />{" "}
              </IconButton>
            )}
            {renderedCrumbs?.map(
              ({ match, breadcrumb, key, location }, index) => {
                const isLast = renderedCrumbs.length - 1 === index;

                return (
                  <Box key={key}>
                    {location.pathname !== key ? (
                      <>
                        {(index > 0 || isSmallScreen) && (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            {isLast ? (
                              <Typography
                                variant="title"
                                sx={{
                                  textDecoration: "none",
                                  fontSize: {
                                    xs: "1rem",
                                    sm: "1.25rem",
                                    md: "1.25rem",
                                  },
                                  margin: 0,
                                  color: theme.palette.secondary[800],
                                  fontWeight: 700,
                                  width: "max-content",
                                }}
                              >
                                {breadcrumb}
                              </Typography>
                            ) : (
                              <Link
                                to={match.pathname}
                                style={{ textDecoration: "none" }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: {
                                      xs: "1rem",
                                      sm: "1.25rem",
                                      md: "1.25rem",
                                    },
                                    fontWeight: 700,
                                    color: "black",
                                    // color: theme.palette.customColors.indigo600,
                                    width: "max-content",
                                  }}
                                >
                                  {breadcrumb}
                                </Typography>
                              </Link>
                            )}
                            {!isLast && (
                              <ChevronRight
                                sx={{
                                  fontSize: "1.5rem",
                                  color: theme.palette.secondary[800],
                                }}
                                style={{ marginTop: "4px" }}
                              />
                            )}
                          </Box>
                        )}
                      </>
                    ) : (
                      <Typography
                        sx={{
                          textDecoration: "none",
                          fontSize: {
                            xs: "1rem",
                            sm: "1.25rem",
                            md: "1.25rem",
                          },
                          margin: 0,
                          color: theme.palette.secondary[800],
                          fontWeight: 700,
                          width: "max-content",
                          ...titleStyle,
                        }}
                      >
                        {breadcrumb}
                      </Typography>
                    )}
                  </Box>
                );
              },
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              flex: { xs: 0, sm: 1 },
              alignItems: "center",
              position: isNotLargeScreen ? "auto" : "auto",
              bottom: isNotLargeScreen ? "auto" : "auto",
              zIndex: 3,
              right: "1rem",
              justifyContent: "flex-end",
            }}
          >
            <Actions />
          </Box>
        </Box>
        <Divider
          sx={{
            marginTop: "1rem",
            background: "#EFEFF2 !important",
            opacity: 1,
          }}
        />
      </Card>
    </>
  );
};

export default BreadcrumbHeader;
